<template>
	<div class="mainTainFundIndex">
		<van-image :src="logo" style="width: 100vw;"/>
		<div :key="el.value" :class="el.value" v-for="el in parts">
			<p class="block-title" v-text="el.label" :style="el.style"></p>
			<van-grid :border="false" :column-num="4" class="itemWire">
				<van-grid-item
					v-for="detail in el.housePickerColumns"
					:key="detail.value" @click="openSub(detail)">
					<van-image class="publicImgCss" :src="detail.image"/>
					<p class="van-card__desc van-ellipsis" v-text="detail.label"/>
				</van-grid-item>
			</van-grid>
		</div>
		<div class="authentication" v-show="!auth" @click="startRegister">
			<van-image :src="noAuth" style="width: 40px;"/>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'MaintainFund',
		components: {},
		data() {
			return {
				logo: require('@/assets/logo.png'),
				noAuth: require('@/assets/noauth.png'),
				auth: false,
				parts: [
					{
						label: '信息公开',
						style: 'border-left: 6px solid #58A3FF;',
						housePickerColumns: [
							{
								value: 'ZCFG',
								image: require('@/assets/zcfg.png'),
								label: '政策法规',
								path: '/public/articleList',
								checkAuth: false
							}, {
								value: 'GGTZ',
								label: '公共通知',
								image: require('@/assets/tzgg.png'),
								path: '/public/articleList',
								checkAuth: false
							},
							{
								value: 'YWZN',
								label: '业务指南',
								image: require('@/assets/ywzn.png'),
								path: '/public/articleList',
								checkAuth: false
							},
							{
								value: 'RDWD',
								label: '热点问答',
								image: require('@/assets/rdwd.png'),
								path: '/public/articleList',
								checkAuth: false
							}
						]
					},
					// {
					// 	label: '维修资金',
					// 	style: 'border-left: 6px solid #f69409;',
					// 	housePickerColumns: [
					// 		{
					// 			value: 'bdfw',
					// 			label: '绑定房屋',
					// 			image: require('@/assets/bdfw.png'),
					// 			path: '/maintainFund/bindingHouse',
					// 			checkAuth: false
					// 		}, {
					// 			value: 'zjcx',
					// 			label: '我的房屋',
					// 			image: require('@/assets/zjcx.png'),
					// 			path: '/maintainFund/houseList',
					// 			checkAuth: false
					// 		},
					// 		{
					// 			value: 'zxbj',
					// 			label: '在线表决',
					// 			image: require('@/assets/zxbj.png'),
					// 			path: '/maintainFund/voteList',
					// 			checkAuth: false
					// 		}, {
					// 			value: 'zxjc',
					// 			label: '在线交存',
					// 			image: require('@/assets/zxjc.png'),
					// 			path: '/maintainFund/houseDeposit',
					// 			checkAuth: false
					// 		}
					// 	]
					// },
					{
						label: '个人中心',
						style: 'border-left: 6px solid #22acdd;',
						housePickerColumns: [
							{
								value: 'smrz',
								label: '实名认证',
								image: require('@/assets/smrz.png'),
								path: '/public/register?redirectUrl=maintainFund',
								checkAuth: true
							}, {
								value: 'xxjl',
								label: '消息记录',
								image: require('@/assets/xxjl.png'),
								path: '/personal/notificationList',
								checkAuth: true
							},
							{
								value: 'htcx',
								label: '合同查询',
								image: require('@/assets/htcx.png'),
								path: '/houseResource/contractQuery',
								checkAuth: true
							},
							{
								value: 'lyb',
								label: '留言板',
								image: require('@/assets/rdwd.png'),
								path: '/personal/messageBoard',
								checkAuth: false
							}
							// {
							// 	value: 'wdpj',
							// 	label: '调查问卷',
							// 	image: require('@/assets/wdpj.png'),
							// 	path: '/public/survey',
							// 	checkAuth: true
							// }
						]
					}
				]
			}
		},
		mounted: function () {
			// 从store取token，判断是否登录
			if (this.$store.getters.token) {
				this.auth = true;
				return;
			}
		},
		methods: {
			openSub(detail) {
				let path = detail.path;
				let label = detail.label;
				if (!this.auth && detail.checkAuth) {
					label = '实名认证'
					path = '/public/register?redirectUrl=maintainFund'
				}
				this.$router.push({
					path: path,
					query: {
						value: detail.value,
						label: encodeURIComponent(label)
					}
				})
			},
			startRegister() {
				this.$router.push({
					path: '/public/register?redirectUrl=maintainFund',
					query: {
						label: encodeURIComponent('实名认证')
					}
				})
			}
		}
	}
</script>
<style>
	.mainTainFundIndex{
		text-align: center;
		background-color: white
	}
	.itemWire{
		justify-content: left;
		border-bottom: 12px solid #F2F2F2;
	}
	.van-grid-item__content{
		padding: 0 !important;
	}
	.publicImgCss{
		width: 70%;
		margin: 0 auto;
		min-height: 70px;
		background-size: contain;
		background-repeat: no-repeat;
	}
	.block-title {
		margin: 35px 15px 10px;
		padding: 0 9px;
		line-height: 16px;
		font-weight: 600;
		font-size: 16px;
		margin-top: 20px;
		margin-bottom: 20px;
		text-align: left;
		font-family: "Helvetica Neue", Helvetica, sans-serif;
	}

	.authentication {
		position: fixed;
		right: 5px;
		top: 80%;
		z-index: 100;
	}
</style>